module.exports = __webpack_public_path__ + "769f950bb77e82c931d330881cdb0905.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/rule-gift2.jpg
// module id = 11
// module chunks = 0 1